/* eslint-disable camelcase */

import Vuetify from '../../plugins/vuetify'
import { CriticalDatasetLabels } from '../../enum'

const _t = (text) => Vuetify.framework.lang.t(text)

export class DetectorFrameHands {
  constructor ({ face_intersection = false, belt_intersection = false, holded_object = false } = {}) {
    this.faceIntersection = face_intersection
    this.beltIntersection = belt_intersection
    this.holdedObject = holded_object
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      face_intersection: this.faceIntersection,
      belt_intersection: this.beltIntersection,
      holded_object: this.holdedObject,
    }
  }

  get textRepresentation () {
    const result = []

    if (this.faceIntersection) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.faceIntersection`))
    }

    if (this.holdedObject) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.holdedObject`))
    }

    return result.map(item => ({
      item,
      color: 'black',
      type: CriticalDatasetLabels.FRAME_HANDS_DETECTOR
    }))
  }
}
